import { render, staticRenderFns } from "./modalOpenHC.vue?vue&type=template&id=0b5c8cca"
import script from "./modalOpenHC.vue?vue&type=script&lang=js"
export * from "./modalOpenHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports